import * as React from "react";
const SvgDownArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 7 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.37466 6.50792V0L2.62534 0V6.50792H0L3.5 10L7 6.50792H4.37466Z", fill: "currentColor" }));
export default SvgDownArrow;
